import { CONSTANTS } from 'config/constants';
import Cookies from 'js-cookie';
import React from 'react';
import { io, Socket } from 'socket.io-client';
const { SOCKET_HOST, SOCKET_ID_KEY, SOCKET_SESSION } = CONSTANTS;

export class Sockets {
    private static _instance: Sockets = new Sockets();
    private socket: Socket | null = null;
    private socketContext: React.Context<Socket> | React.Context<null> = React.createContext(null);

    constructor() {
        if (Sockets._instance) {
            throw new Error('Singleton class');
        }
        Sockets._instance = this;
    }

    public static get instance(): Sockets {
        return Sockets._instance;
    }

    getSocket(): Socket {
        return this.socket as Socket;
    }

    connectToWs(url = '/'): void {
        const socketPath = `${SOCKET_HOST}${url}`;

        const socket = io(socketPath, {
            auth: { token: Cookies.get(CONSTANTS.TOKEN_KEY) },
            reconnectionAttempts: 10,
        });

        this.socket = socket;
        this.socketContext = React.createContext(socket);

        socket.on('disconnect', () => {
            console.log(`connection closed at ${url}`);
        });

        socket.on('connect', () => {
            console.log(socket.id, 'socket');
            socket.on('SESSION_STR', (sessionStr: string) => {
                sessionStorage.setItem(SOCKET_SESSION, sessionStr);
            });
            sessionStorage.setItem(SOCKET_ID_KEY, socket.id || '');
        });

        socket.on('connect_error', (err) => {
            console.log(err.message);
        });
    }

    getSocketContext(): React.Context<Socket> {
        return this.socketContext as React.Context<Socket>;
    }
}

export const socketIo = Sockets.instance;
